<template>
  <div class="chart-box">
    <el-row :gutter="20" style="margin: 30px 0;">
      <el-col :span="6">
        <centerLeft defultIndex="2-3" />
      </el-col>
      <el-col :span="18">
        <el-card class="box-card" shadow="never">
          <el-breadcrumb
            separator-class="el-icon-arrow-right"
            class="type-opr"
            style="margin:0 0  10px 0;"
          >
            <el-breadcrumb-item :to="{ path: '/center/index' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>草稿箱</el-breadcrumb-item>
          </el-breadcrumb>
          <el-card class="box-card" shadow="never">
            <div slot="header" class="clearfix">
              <span>草稿箱</span>
            </div>
            <el-card class="box-card" style="margin-bottom: 20px;" shadow="never">
              <el-form ref="form" :model="searchForm" class="department-form" size="medium">
                <div class="el-form-item" style="width: 600px;">
                  <el-input
                    placeholder="请输入内容"
                    v-model="searchForm.search"
                    class="input-with-select"
                  >
                    <el-button @click="searchData" slot="append" plain icon="el-icon-search">检索</el-button>
                  </el-input>
                </div>
              </el-form>
            </el-card>
            <el-card class="box-card" shadow="never">
              <el-table :data="tableData" style="width: 100%">
                <el-table-column label="名称" min-width="300px">
                  <template slot-scope="scope">
                    <span
                      @click="toUpdateDiss(scope.row.baseType,scope.row.baseId,scope.row.vipFlag)"
                      size="small"
                    >{{scope.row.title}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="showPublish" label="创建时间" width="180"></el-table-column>
                <el-table-column prop="showPublish" label="状态" width="180"></el-table-column>
              </el-table>
              <el-pagination
                background
                layout="prev, pager, next"
                :total="total"
                :current-page="currentPage"
                :page-size="pageSizes"
                @current-change="currentChange"
                style="text-align: right"
              ></el-pagination>
            </el-card>
          </el-card>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import centerLeft from '../../components/center-left.vue'
export default {
  name: 'claim',
  components: {
    centerLeft,
  },
  data() {
    return {
      activeName: 'second',
      isRouter: true,
      activeIndex: '1-1',
      searchForm: {
        search: '',
        pageNo: 1,
      },
      total: 0,
      currentPage: 1,
      pageSizes: 5,
      tableData: [],
      userId: '',
    }
  },
  methods: {
    currentChange(val) {
      this.searchForm.pageNo = val
      this.searchData()
    },
    searchData() {
      this.userId = localStorage.getItem('userId')
      let currThis = this
      let data = this.searchForm
      console.log(this.userId)
      axios({
        method: 'get',
        url:
          '/api/member/queryDtjData?pageNo=' +
          data.pageNo +
          '&claimUserId=' +
          this.userId +
          '&search=' +
          data.search,
      })
        .then(function (response) {
          console.log(response)
          currThis.total = response.data.pageTotal
          currThis.tableData = response.data.list
        })
        .catch(function (thrown) {
          console.log(thrown)
        })
    },
    toUpdateDiss(val1, val2, val3) {
      if (val1 == 'irBooks') {
        //window.location.href = "/front/member/books/initAdd/21/" + val2;
      } else if (val1 == 'irScientifictask') {
        //window.location.href = "/front/member/scientifictask/initAdd/21/" + val2;
      } else if (val1 == 'irDegreeDiss') {
        //window.location.href = "/front/member/degree/initAdd/21/" + val2;
      } else if (val1 == 'irForeginDiss') {
        this.$router.push({
          path: '/center/foreign',
          query: { id: val2 },
        })
      } else if (val1 == 'irJournalDiss') {
        this.$router.push({
          path: '/center/china',
          query: { id: val2 },
        })
      } else if (val1 == 'irMeetingDiss') {
        //window.location.href = "/front/member/meeting/initAdd/21/" + val2;
      } else if (val1 == 'irPatent') {
        //window.location.href = "/front/member/patent/initAdd/21/" + val2;
      } else {
        //window.location.href = "/front/member/others/initAdd/21/" + val2;
      }
    },
  },
  mounted() {
    this.userId = localStorage.getItem('userId')
    this.searchData()
    console.log(this.userId)
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/center/drafts.vue